"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CreateTeamModal_module_css_1 = __importDefault(require("./CreateTeamModal.module.css"));
var react_i18next_1 = require("react-i18next");
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var Checkbox_1 = __importDefault(require("../common/Checkbox"));
var RoleCheckboxList = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("div", { className: CreateTeamModal_module_css_1.default.role_list_container }, props.roles.map(function (role) {
        var _a, _b;
        return (react_1.default.createElement("div", { key: role.id, className: CreateTeamModal_module_css_1.default.role_list },
            react_1.default.createElement(Tooltip_1.default, { className: "ns-font-family", title: react_1.default.createElement("span", { style: { margin: 0, padding: 0, whiteSpace: "pre-wrap" } }, t((_a = role.description) !== null && _a !== void 0 ? _a : "")), placement: "top", arrow: true, PopperProps: {
                    sx: {
                        ".MuiTooltip-arrow": {
                            color: "var(--secondary-color)",
                        },
                        ".MuiTooltip-tooltip": {
                            backgroundColor: "var(--secondary-color)",
                            color: "var(--info-color)",
                            borderRadius: "7px",
                            padding: "12px"
                        },
                    },
                } },
                react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
                    react_1.default.createElement("span", { className: CreateTeamModal_module_css_1.default.span_text }, t((_b = role.display_name) !== null && _b !== void 0 ? _b : "")))),
            react_1.default.createElement(Checkbox_1.default, { checked: role.isChecked, onChange: function () { return props.changeHandler(role.id); }, "data-cy": role.name })));
    })));
};
exports.default = RoleCheckboxList;
